var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    fill: "#ECECEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2687 12.1583C30.0863 12.7804 30.5654 13.7482 30.5654 14.7756V25.6661C30.5654 27.4834 29.0922 28.9566 27.2748 28.9566H9.72544C7.90814 28.9566 6.43492 27.4834 6.43492 25.6661V14.7756C6.43492 13.7482 6.91397 12.7804 7.73165 12.1583C10.1284 10.3347 15.1343 6.5279 16.5258 5.48427C17.6958 4.6068 19.3045 4.6068 20.4744 5.48427C21.8659 6.52789 26.8719 10.3347 29.2687 12.1583ZM8.6286 14.8829L16.4612 21.0665C17.6567 22.0103 19.3436 22.0103 20.5391 21.0665L28.3717 14.8829V25.6661C28.3717 26.2719 27.8806 26.7629 27.2748 26.7629H9.72544C9.11967 26.7629 8.6286 26.2719 8.6286 25.6661V14.8829ZM19.1582 7.23922L27.0327 13.1451L19.1797 19.3447C18.7813 19.6594 18.219 19.6594 17.8205 19.3447L9.96758 13.1451L17.842 7.23922C18.2321 6.94672 18.7682 6.94672 19.1582 7.23922Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.555ab6dc207380483eb58127b9de497a.svg";
export { ForwardRef as ReactComponent };